import React, { useRef, useState } from 'react';
import s from '../styles/ExcelUploadModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

const ExcelUploadModal = ({ googleId, projectId, onClose }) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setErrorText("");
    }
  };

  const handleUpload = async () => {
    const file = fileInputRef.current?.files[0];
    if (!file) {
      setErrorText("❗ Пожалуйста, выберите файл.");
      return;
    }

    setLoading(true);
    setErrorText("");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("google_id", googleId);
    formData.append("project_id", projectId);

    try {
      const res = await fetch("https://pulseads.ru/upload-excel", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();
      if (!res.ok || result.success !== "Готово") {
        throw new Error(result.error || "Ошибка при загрузке");
      }

      toast.success("📊 Данные загружаются. Уведомление придёт в Telegram.");
      onClose();
    } catch (err) {
      setErrorText("❌ Ошибка добавления файла, проверьте ссылку на таблицу.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={s.modal_overlay} onClick={onClose}></div>
      <div className={s.excel_modal}>
        <div className={s.header}>
          <button className={s.close_btn} onClick={onClose}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>
        <div className={s.content}>
        <div className={s.primary_text}>
                <p className={s.title}>📊 Загрузка Excel-файла</p>
                <p className={s.paragraph}>
                  После загрузки данные начнут обрабатываться. Это может занять до <strong>5 минут</strong> на каждые 5 000 объявлений.
                </p>
                <p className={s.paragraph}>
                  ✅ Когда загрузка завершится, вы получите <strong>уведомление в Telegram</strong> в течение <strong>1–3 минут</strong>.
                </p>
                <p className={s.paragraphFinal}>
                  📂 Пожалуйста, выберите файл для загрузки:
                </p>
              </div>

          
          <label className={s.customFileUpload}>
            <FontAwesomeIcon icon={faFolderOpen} className={s.folder_icon} />
            <input
              type="file"
              ref={fileInputRef}
              accept=".xlsx"
              onChange={handleFileChange}
              className={s.hiddenInput}
            />
          </label>

          {fileName && <div className={s.fileName}>{fileName}</div>}
          {errorText && <div className={s.error_text}>{errorText}</div>}

          <button
            onClick={handleUpload}
            disabled={loading || !fileName}
            className={s.upload_btn}
          >
            {loading ? <div className={s.spinner}></div> : "Загрузить"}
          </button>
        </div>
      </div>
    </>
  );
};

export default ExcelUploadModal;

